<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>

    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte Reembolsos</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>RP_Reembolsos</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Generación de reporte de Reembolsos
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row class="mt-3">
            <b-col>
              <b-form-group align="left">
                <label>Fecha de inicio</label>
                <b-input-group size="sm" class="mb-2" id="fci" lab>
                  <b-form-datepicker name="nombre" placeholder="Fecha de Inicio"
                                     v-model="$v.filtro.fechaInicio.$model"
                                     :state="validateState('fechaInicio')"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Fecha de fin</label>
                <b-input-group size="sm" class="mb-2" id="fcf" lab>
                  <b-form-datepicker name="nombre" placeholder="Fecha de Fin"
                                     :min="filtro.fechaInicio"
                                     :max="new Date()"
                                     v-model="$v.filtro.fechaFin.$model"
                                     :state="validateState('fechaFin')"

                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row align-v="center" align-h="end">
            <b-col>
              <b-form-group align="left">
                <label>Clínicas</label>
                <v-select v-if="!todasClinicas" name="clinica" placeholder="Clínicas"
                          label="strNombre"
                          multiple
                          :reduce="(variable) => variable.idClinica"
                          :options="clinicas"
                          v-model="filtro.idClinicas"
                ></v-select>
                <b-form-checkbox
                    id="checkbox-1"
                    v-model="todasClinicas"
                    name="checkbox-1"
                    @change="checkTodasClinicas()">
                  Todas las clinicas
                </b-form-checkbox>
              </b-form-group>

            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Áreas</label>
                <v-select v-if="!todasAreas" name="clinica" placeholder="Áreas"
                          label="nombreArea"
                          multiple
                          :reduce="(variable) => variable.idArea"
                          :options="areas"
                          v-model="filtro.idAreas"
                ></v-select>
                <b-form-checkbox
                    id="checkbox-2"
                    v-model="todasAreas"
                    name="checkbox-2"
                    @change="checkTodasAreas()">
                  Todas las áreas
                </b-form-checkbox>
              </b-form-group>

            </b-col>
          </b-row>

          <b-row>
            <b-col></b-col>
            <b-col></b-col>
            <b-col class="text-right">
              <span v-if="$localStorageService.can('RP_01_excel_reembolsos')">
                <download-excel
                    v-if="datosTabla.length > 0"
                    class="btn btn-outline-success mr-4"
                    :data="datosTabla"
                    :fields="fieldsExcel"

                    worksheet="My Worksheet"
                    :name="'Reporte_Reembolsos_'+$formatoFecha(new Date())+'.xls'"
                >
                  Generar Excel
                  <em class="fa fa-file-excel-o"></em>
                </download-excel>
                </span>
              <b-button variant="outline-primary" :disabled="loader" @click="obtenerDatos()">
                <span v-if="!loader">Buscar</span>
                <span v-else>
                  <b-spinner small></b-spinner>
                  Buscando...
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <div class="mt-2 col-md-12"></div>

      <b-row>
        <b-col cols="12">
          <b-table
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive
              class="parrafos">

          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No se encontraron datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
import Header from "@/components/Header";
import {required} from "vuelidate/lib/validators";
import {AreaService} from "@/apiServices/area/AreaService";
import {ReportesService} from "@/apiServices/reportes/ReportesService";

export default {
  components: {Header},
  name: "reporteReembolsos",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    areaService: new AreaService(),
    reportesService: new ReportesService(),
    todasClinicas: false,
    todasAreas: false,
    paginaActual: 1,
    filtro: {
      idClinicas: [],
      idAreas: [],
      fechaInicio: null,
      fechaFin: null
    },
    clinicas: [],
    areas: [],
    loader: false,
    buscado: false,
    datosTabla: [],
    fields: [],
    fieldsExcel:{
      "No." : "folio",
      "Fecha Solcicitud" : "fechaSolicitud",
      "ID Paciente" : "idPaciente",
      "Nombre Paciente" : "nombrePaciente",
      "Clínica" : "clinica",
      "Region" : "region",
      "Reembolso" : "reembolso",
      "Área" : "area"
    }
  }),
  validations: {
    filtro: {
      fechaInicio: {required},
      fechaFin: {required},
    }
  },
  mounted() {
    this.fields = [
      {key: "folio", label: "No.", sortable: true},
      {key: "fechaSolicitud", label: "Fecha Solicitud", sortable: true},
      {key: "idPaciente", label: "ID Paciente", sortable: true},
      {key: "nombrePaciente", label: "Nombre Paciente", sortable: true},
      {key: "clinica", label: "Clínica", sortable: true},
      {key: "region", label: "Region", sortable: true},
      {key: "reembolso", label: "Reembolso", sortable: true, formatter: this.$formatoMoneda},
      {key: "area", label: "Área", sortable: true},
    ];
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerClinicas();
    this.areas = await this.areaService.listar();
  },
  methods: {
    obtenerClinicas() {
      this.$http.get(this.$api + 'catalogos/listaClinicas').then(respuesta => {
        if (respuesta.data.data) {
          this.clinicas = respuesta.data.data;
        }
      })
    },
    obtenerDatos(){
      this.$v.filtro.$touch();
      if(this.validarDatos()){
        if (!this.$v.filtro.$invalid) {
          this.loader = true
          this.buscado = false
          this.datosTabla = [];

          const envio = {
            idClinicas: this.todasClinicas ? this.clinicas.map(c => c.idClinica) : this.filtro.idClinicas,
            idAreas: this.todasAreas ? this.areas.map(a => a.idArea): this.filtro.idAreas,
            fechaInicio: this.$moment(this.filtro.fechaInicio).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
            fechaFin: this.$moment(this.filtro.fechaFin).add(1, 'days').utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
          }

          this.reportesService.obtenerReporteReembolsos(envio).then((respuesta) => {
            this.datosTabla = respuesta;
          }).finally(() => {
            this.loader = false;
            this.buscado = true;
            this.paginaActual = 1;
          });
        }
      }else{
        return false
      }

    },
    validarDatos(){
      if (!this.todasClinicas && this.filtro.idClinicas.length === 0) {
        this.$swal({
          icon: "error",
          text: "Debe seleccionar al menos una clínica para realizar la búsqueda",
        });
        return false;
      }
      if (!this.todasAreas && this.filtro.idAreas.length === 0) {
        this.$swal({
          icon: "error",
          text: "Debe seleccionar al menos una área para realizar la búsqueda",
        });
        return false;
      }
      return true;
    },
    checkTodasClinicas() {
      this.todasClinicas = !this.todasClinicas;
      this.filtro.idClinicas = [];
    },
    checkTodasAreas() {
      this.todasAreas = !this.todasAreas;
      this.filtro.idAreas = [];
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },
  }


}
</script>

<style scoped>

</style>
